__webpack_require__.p = "/videopoker/";